var days = [0, 1, 2, 3, 4, 5, 6];
// Given a start day of week, return an array of day indexes starting at that given day.
export default function rotateDayIndexes(startOfWeek) {
    function mapDay(_, i) {
        return days[(i + startOfWeek) % 7];
    }
    return days.map(mapDay);
}
//# sourceMappingURL=rotate-day-indexes.js.map